export const SIGNATURE_TEMPLATE_URL = "/assets/templates/signature-template.pdf";
export const SIGNATURE_TEMPLATE_FILENAME = "signature-template.pdf";
